export const MAX_FLOOR_COUNT = 9999;
